import React from 'react';
import { menuLinks } from './header/account-menu/menuLinks';
import styled from 'styled-components';
import { ENABLE_DEVELOPER_LINKS, PATH_DASHBOARD } from '../constants';
import { Link } from 'react-router-dom';
import { GroupTitle, LinkContainer } from './SideNavOrg';
import css from '../../../css/css-variables';
import UserIcon from '../../../img/sprite/indv-user-icon.svg';

const StyledLink = styled(Link)`
  border: none;
  font-size: 16px;
  color: ${css.colors.Progress};
  text-decoration: none;
  ${({activeLink}) => activeLink && 'pointer-events: none'};
  font-weight: ${({bold}) => bold ? 'bold' : 'normal'};
  padding: 8px 0;

  &:hover {
    text-decoration: ${({activeLink}) => activeLink ? 'none' : 'underline'};
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0 10px;
`;

export const StyledSvg = styled.svg`
  height: ${({height}) => height ? height : '48px'};
  width: ${({width}) => width ? width : '48px'};
  ${({ flexShrink }) => flexShrink && `flex-shrink: ${flexShrink};`}
  margin-right: ${({marginRight}) => marginRight ? marginRight : '12px'};
  ${({ display }) => display && `display: ${display}`};
`;

export const SectionHeader = styled.h1`
  font-size: ${({ fontSize}) => fontSize ? fontSize : '16px' };
  color: ${css.colors.DarkGray};
  text-decoration: none;
  font-weight: ${({bold}) => bold ? 'bold' : 'normal'};
  width: fit-content;
`;


function SideNavIndividual({ pathname, currentUser }) {
  const userName = currentUser?.fullName;

  const filteredMenuLinks = menuLinks?.linkGroup.filter(
    group => group.title !== 'Developer Links' || ENABLE_DEVELOPER_LINKS
  );

  return (
    <>
      <div>
        <HeaderWrapper>
          <StyledSvg flexShrink="0">
            <use href={`#${UserIcon.id}`} />
          </StyledSvg>
          <SectionHeader bold={true}>
            {userName}
          </SectionHeader>
        </HeaderWrapper>
        <div style={{padding: '0 0 7px 0'}}>
          <StyledLink
            to={PATH_DASHBOARD}
            style={{
              fontSize: '14px',
              color: pathname === PATH_DASHBOARD ? '#414042' : css.colors.Progress,
              fontWeight: pathname === PATH_DASHBOARD ? 'bold' : 'normal'
            }}
            activeLink={pathname === PATH_DASHBOARD}
          >
            Home
          </StyledLink>
        </div>
        {filteredMenuLinks.map((group, index) => {
        const isLastChild = filteredMenuLinks.length -1 === index;
        return (
          <div key={index}>
            {group?.title && <GroupTitle isLastChild={isLastChild} title={group.title}>{group.title}</GroupTitle>}
            {group.links.map((link, index) => {
              return (<div style={{ padding: '0 0 8px 0'}}>
                <StyledLink
                  bold={false}
                  to={link.url}
                  style={{
                    marginTop: '0',
                    fontSize: '14px',
                    color: pathname.includes(link.url) ? '#414042' : pathname.includes('manage-access') && link.url.includes('manage-access') ? '#414042' : css.colors.Progress,
                    fontWeight: pathname.includes(link.url) ? 'bold' : pathname.includes('manage-access') && link.url.includes('manage-access') ? 'bold' : 'normal',
                  }}
                  activeLink={pathname.includes(link.url)}
                >
                  <LinkContainer>{link.name}</LinkContainer>
                </StyledLink>
              </div>
            )})}
          </div>
        )})}
      </div>
    </>
  );
}

export default SideNavIndividual;